var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPayflows = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.84128 6.88889C2.24064 6.88889 1.67775 7.1806 1.33316 7.67044C0.988569 8.16029 0.905602 8.7867 1.11087 9.34875L6.02092 22.7932C6.28552 23.5177 6.97707 24 7.75133 24H21.254C21.8546 24 22.4175 23.7083 22.7621 23.2184C23.1067 22.7286 23.1897 22.1022 22.9844 21.5401L22.0973 19.1111H10.2069C9.43267 19.1111 8.74113 18.6288 8.47653 17.9043L4.45358 6.88889H2.84128Z",
    fill: "#60C8E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29631 2C4.69566 2 4.13277 2.29171 3.78818 2.78155C3.44359 3.2714 3.36063 3.89781 3.56589 4.45986L4.45358 6.88889H16.3445C17.1188 6.88889 17.8103 7.37118 18.0749 8.09569L22.0973 19.1111H23.709C24.3097 19.1111 24.8725 18.8194 25.2171 18.3296C25.5617 17.8397 25.6447 17.2133 25.4394 16.6512L20.5294 3.2068C20.2648 2.48229 19.5732 2 18.799 2H5.29631Z",
    fill: "#425EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0973 19.1111H10.2069C9.43267 19.1111 8.74113 18.6288 8.47653 17.9043L4.45358 6.88889H16.3445C17.1188 6.88889 17.8103 7.37118 18.0749 8.09569L22.0973 19.1111Z",
    fill: "#2E3F9D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPayflows);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/payflows.bf09cdf4fe5fb48f459d328cdf95134c.svg";